<ngx-extended-pdf-viewer
[src]="'/assets/pdf/CGU.pdf'"
[useBrowserLocale]="true"
[textLayer]="true"
[showHandToolButton]="true" 
[showPresentationModeButton]="true">
  [showDownloadButton]="false">
</ngx-extended-pdf-viewer>   
